module.exports = __webpack_public_path__ + "static/img/TJ.60e702c6.png";